import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Input, Label, Spinner, Modal, ModalBody, ModalFooter } from 'reactstrap';
import _ from 'lodash';
import { useParams } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import Select from 'react-select';
import {
  datesFormat,
  REACT_APP_GROUP_CONFIG as countryGroups,
  REACT_APP_PUBLIC_GROUP_CONFIG as publicSaleGroup,
} from '../../config';
import Translate, { t } from '../common/Translate';
import '../../assets/scss/react-datepicker.css';
import Switch from '../Switch/Switch';
import useRecord from '../../Store/uses/useRecord';
import InfoBullItem from '../Switch/InfoBull';
import { recordActions, Auth } from '../../config/configuration/react';

const ManuelSale = ({
  postOffer,
  postAnnonceAt,
  showForm,
  offers,
  showManualTitle,
  counterInspection,
  recordTypeId,
  expertiseCosts,
}) => {
  const { recordId } = useParams();
  const dispatch = useDispatch();
  const { record, isRecordLoading, errorRecordApi } = useRecord(recordId);
  const [isLoading, setisLoading] = useState(false);
  const data = record;
  const [disabled, setDisabled] = useState(true);
  const [apiErrorMessage, setApiErrorMessage] = useState(false);
  const [body, setBody] = useState({
    comment: '',
    sale_offer_type: '/api/sale_offer_types/1',
    accept_auction: false,
    accept_immediate_purchase: false,
    accept_submission: false,
    auction_start_price: null,
    auction_step_price: null,
    auction_reserve_price: null,
    immediate_purchase_price: null,
    startDate: moment().format('YYYY-MM-DD'),
    startTime: moment().format('HH:mm'),
    start_date_time: null,
    endDate: moment().add(3, 'days').format('YYYY-MM-DD'),
    endTime: moment().add(3, 'days').format('HH:mm'),
    end_date_time: null,
    express_sale: false,
    distribution_lists: [],
    publicOption: '',
  });
  const [errorPrice, setErrorPrice] = useState(false);
  const [errorAuctionReservePrice, setErrorAuctionReservePrice] = useState(false);
  const [errorAuctionStartPrice, setErrorAuctionStartPrice] = useState(false);
  const [errorDate, setErrorDate] = useState(false);
  const appLang = Auth.preferredLanguage().toUpperCase();
  const [tooltipOpen, setTooltipOpen] = useState({ first: false, second: false, third: false });
  const [btnPublic, setBtnPublic] = useState(false);
  const [btnPrivate, setBtnPrivate] = useState(false);
  const [groupList, setGroupList] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [btnNationalSale, setBtnNationalSale] = useState(false);
  const [requiredError, setRequiredError] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };
  const handleChangePublicSale = (e) => {
    setBtnPublic(!btnPublic);
    if (e.target.checked) {
      setBtnPrivate(false);
      setBtnNationalSale(false);
      const distribution_lists = publicSaleGroup;
      setBody({ ...body, distribution_lists, publicOption: e.target.name });
    } else setBody({ ...body, distribution_lists: null, publicOption: '' });
  };
  const handleChangeNationalSale = (e) => {
    const country = Auth.country();
    setBtnNationalSale(!btnNationalSale);
    if (e.target.checked) {
      setBtnPublic(false);
      setBtnPrivate(false);
      const distribution_lists = countryGroups[country];
      setBody({ ...body, distribution_lists, publicOption: e.target.name });
    } else {
      setBody({ ...body, distribution_lists: null, publicOption: '' });
    }
  };

  const handleChangePrivateSale = (e) => {
    setBtnPrivate(!btnPrivate);

    if (e.target.checked) {
      setBody({
        ...body,
        distribution_lists: [],
        publicOption: e.target.name,
      });
      setBtnPublic(false);
      setBtnNationalSale(false);
    } else {
      setBody({
        ...body,
        publicOption: '',
      });
    }
  };

  const getGroupList = async () => {
    const { hasGroups } = await dispatch(recordActions.fetchGroupUserInfos());
    if (hasGroups) return hasGroups.filter((i) => i.id !== 34);
    return [];
  };

  useEffect(() => {
    if (btnPrivate) {
      getGroupList().then((res) => {
        if (res.length === 0) {
          setIsOpen(true);
          setBtnPrivate(false);
          setBody((prev) => ({
            ...prev,
            publicOption: '',
            distribution_lists: [],
          }));
          return;
        }
        const mappedGroups = res.map((i) => ({
          value: i.id,
          label: i.name,
        }));
        setGroupList(mappedGroups);
        setBody((prev) => ({
          ...prev,
          distribution_lists: res.length === 1 ? [res[0].id] : [],
        }));
      });
    }
  }, [btnPrivate]);

  const openInfoBull = (target) => {
    const res = { ...tooltipOpen };
    res[target] = !res[target];
    setTooltipOpen(res);
  };

  const isSaleEmpty = () => {
    let empty = false;
    const accept_auction = _.get(body, 'accept_auction', null);
    const auction_start_price = _.get(body, 'auction_start_price', null);
    const auction_step_price = _.get(body, 'auction_step_price', null);
    const accept_immediate_purchase = _.get(body, 'accept_immediate_purchase', null);
    const immediate_purchase_price = _.get(body, 'immediate_purchase_price', null);
    const accept_submission = _.get(body, 'accept_submission', null);

    if (accept_auction === true && accept_immediate_purchase === true) {
      empty = !!(auction_start_price === null || auction_step_price === null || immediate_purchase_price === null);
    } else if (accept_auction === false && accept_immediate_purchase === true) {
      empty = immediate_purchase_price === null;
    } else if (accept_auction === true && accept_immediate_purchase === false) {
      empty = !!(auction_start_price === null || auction_step_price === null);
    } else if (accept_auction === false && accept_immediate_purchase === false && accept_submission === true) {
      empty = false;
    } else if (accept_auction === false && accept_immediate_purchase === false && accept_submission === false) {
      empty = true;
    }

    return empty;
  };

  const isBodyEmpty = () => {
    let empty = false;
    const saleKeys = [
      'accept_auction',
      'auction_start_price',
      'auction_step_price',
      'accept_immediate_purchase',
      'immediate_purchase_price',
      'accept_submission',
    ];

    Object.entries(body).forEach(([k, v]) => {
      if (saleKeys.includes(k)) {
        empty = isSaleEmpty(empty);
      } else if (v === null || v === '') empty = true;
    });
    return empty;
  };

  useEffect(() => {
    if (isBodyEmpty() || errorPrice || errorAuctionReservePrice || errorAuctionStartPrice || requiredError) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [body]);

  const handleCreate = async () => {
    setisLoading(true);

    Object.entries(body).forEach(([k, v]) => {
      if (v === true) _.set(body, `${k}`, 1);
      if (v === false) _.set(body, `${k}`, 0);
      if (v === null) _.set(body, `${k}`, 0);
      if (k === 'fileNumber') {
        _.set(body, `${k}`, _.get(data, 'record.refHexaId', null));
      }
      if (k === 'start_date_time' || k === 'end_date_time') {
        const formattedDate = moment(v).format('YYYY-MM-DD HH:mm:ss');
        _.set(body, `${k}`, formattedDate);

        if (k === 'end_date_time') {
          _.set(body, 'endTime', moment(v).format('HH:mm'));
        } else if (k === 'start_date_time') {
          _.set(body, 'startTime', moment(v).format('HH:mm'));
        }
      }
    });

    const response = await postOffer();
    if (response.id) {
      await postAnnonceAt({ ...body, vehicleId: response.id });
      // setRedirect(`/files/${recordId}`);
    } else {
      setApiErrorMessage(response.message);
    }

    setisLoading(false);
  };

  const accept_auction = _.get(body, 'accept_auction', null);
  const auction_start_price = _.get(body, 'auction_start_price', null);
  const auction_step_price = _.get(body, 'auction_step_price', null);
  const auction_reserve_price = _.get(body, 'auction_reserve_price', null);
  const accept_immediate_purchase = _.get(body, 'accept_immediate_purchase', null);
  const immediate_purchase_price = _.get(body, 'immediate_purchase_price', null);
  const accept_submission = _.get(body, 'accept_submission', null);
  const endDate = _.get(body, 'endDate', null);
  const endTime = _.get(body, 'endTime', null);
  const startDate = _.get(body, 'startDate', null);
  const startTime = _.get(body, 'startTime', null);
  let purchasePriceClass;
  let errorAuctionReservePriceClass;
  let errorAuctionStartPriceClass;

  if (accept_immediate_purchase) {
    if (errorPrice || parseInt(immediate_purchase_price, 10) < parseInt(auction_start_price, 10)) {
      purchasePriceClass = 'rounded error';
    } else {
      purchasePriceClass = 'rounded';
    }
  }
  if (accept_auction) {
    if (errorAuctionReservePrice) {
      errorAuctionReservePriceClass = 'rounded error';
    } else {
      errorAuctionReservePriceClass = 'rounded';
    }
    if (errorAuctionStartPrice) {
      errorAuctionStartPriceClass = 'rounded error';
    } else {
      errorAuctionStartPriceClass = 'rounded';
    }
  }

  useEffect(() => {
    let auctionStepPriceValue;
    let auctionStartPriceValue = _.get(body, 'auction_start_price', null);
    const auctionReservePriceValue = _.get(body, 'auction_reserve_price', null);

    if (accept_auction && !auction_step_price) {
      auctionStepPriceValue = 100;
    } else if (!accept_auction) {
      auctionStepPriceValue = 0;
      auctionStartPriceValue = null;
    }
    setBody({
      ...body,
      auction_step_price: auctionStepPriceValue,
      auction_start_price: auctionStartPriceValue,
      auction_reserve_price: auctionReservePriceValue,
    });
  }, [accept_auction]);

  useEffect(() => {
    if (!accept_immediate_purchase) {
      setBody({
        ...body,
        immediate_purchase_price: null,
      });
    }
  }, [accept_immediate_purchase]);

  useEffect(() => {
    let end_date_time = null;
    let start_date_time = null;
    if (endDate && endTime) {
      end_date_time = moment(`${endDate}T${endTime}`).format('YYYY-MM-DD HH:mm:ss');
      const diff = moment(end_date_time).isSameOrBefore(
        moment(`${startDate}T${startTime}`).format('YYYY-MM-DD HH:mm:ss'),
      );
      setErrorDate(diff);
      if (diff === true) {
        end_date_time = null;
      }
    }
    if (startDate && startTime) {
      start_date_time = moment(`${startDate}T${startTime}`).format('YYYY-MM-DD HH:mm:ss');
      const diff = moment(start_date_time).isSameOrAfter(moment(`${endDate}T${endTime}`).format('YYYY-MM-DD HH:mm:ss'));
      setErrorDate(diff);
      if (diff === true) {
        start_date_time = null;
      }
    }
    setBody({
      ...body,
      end_date_time,
      start_date_time,
    });
  }, [endDate, endTime, startDate, startTime]);

  return (
    <>
      {(errorRecordApi && (
        <p className="text-danger">
          <Translate code={errorRecordApi} />
        </p>
      )) ||
        (isRecordLoading && (
          <div className="loader-full-screen main">
            <Spinner />
          </div>
        )) ||
        (apiErrorMessage && (
          <Row>
            <Col xs="12" sm="6" lg="5" xl="4">
              <p>{apiErrorMessage}</p>
              <button
                className="btn btn-outline-secondary btn-block"
                type="button"
                onClick={() => setApiErrorMessage(false)}
              >
                {t('back')}
              </button>
            </Col>
          </Row>
        )) || (
          <>
            {showForm && (
              <>
                {offers && showManualTitle && (
                  <Row className="mt-2">
                    <Col xs="12" sm="6" lg="5" xl="4">
                      <font className="text-primary text-left" size="5">
                        <Translate code="put_back_online" />
                      </font>
                    </Col>
                  </Row>
                )}

                {counterInspection?.recordId && (
                  <div className="contreInspection-bloc">
                    <div className="first-bloc">
                      <Row>
                        <Col xs="6" sm="6" lg="6">
                          {(recordTypeId === 1 && t('counterAppraisalLinked')) || t('initialAppraisal')}
                        </Col>
                        <Col xs="6" sm="6" lg="6" className="value">
                          {counterInspection?.refHexaId}
                        </Col>
                      </Row>
                      <Row>
                        <Col xs="6" sm="6" lg="6">
                          {t('finalOfferAt')}
                        </Col>
                        <Col xs="6" sm="6" lg="6" className="value">
                          {(counterInspection?.finalPrice && (
                            <>
                              {parseInt(counterInspection?.finalPrice, 10)}
                              <Translate code="€ TTC" />
                            </>
                          )) ||
                            '-'}
                        </Col>
                      </Row>
                    </div>
                    <div className="second-bloc">
                      <Row>
                        {recordTypeId === 1 && (
                          <>
                            <Col xs="6" sm="6" lg="6">
                              {t('CostAppraisalaT')}
                            </Col>
                            <Col xs="6" sm="6" lg="6" className="value">
                              {(expertiseCosts && (
                                <>
                                  {parseInt(expertiseCosts, 10)}
                                  <Translate code="€ TTC" />
                                </>
                              )) ||
                                '-'}
                            </Col>
                          </>
                        )}
                      </Row>
                      <Row>
                        <Col xs="6" sm="6" lg="6">
                          {t('CostCounterAppraisalaT')}
                        </Col>
                        <Col xs="6" sm="6" lg="6" className="value">
                          {(counterInspection?.cost && (
                            <>
                              {parseInt(counterInspection?.cost, 10)}
                              <Translate code="€ TTC" />
                            </>
                          )) ||
                            '-'}
                        </Col>
                      </Row>
                    </div>
                  </div>
                )}

                <Row>
                  <Col xs="12" sm="6" lg="5" xl="4">
                    <div className="pl-2">
                      <table className="sales-table">
                        <tbody>
                          <tr>
                            <td>
                              <small className="text-primary text-bold">{t('acceptAuction')}</small>
                            </td>

                            <td>
                              <Switch
                                isOn={accept_auction}
                                onColor="#273C78"
                                id="acceptAuction"
                                name="acceptAuction"
                                handleToggle={(e) => {
                                  setBody({
                                    ...body,
                                    accept_auction: e.target.checked,
                                  });
                                }}
                              />
                            </td>
                          </tr>

                          <tr>
                            <td>
                              <small className="text-primary">{t('auctionStartPrice')}</small>
                              <br />
                              {errorAuctionStartPrice && (
                                <small
                                  className="text-danger d-inline-block w-75 d-sm-inline"
                                  style={{ lineHeight: 1.4 }}
                                >
                                  <Translate code="errorAuctionStartPrice" />
                                </small>
                              )}
                            </td>
                            <td>
                              <input
                                type="number"
                                id="auctionStartPrice"
                                name="auctionStartPrice"
                                maxLength="4"
                                size="4"
                                min="1"
                                className={errorAuctionStartPriceClass || 'rounded disabled'}
                                disabled={accept_auction !== true}
                                value={accept_auction === true ? auction_start_price : ''}
                                onChange={(e) => {
                                  let value = parseInt(e.target.value, 10);

                                  if (value && value >= parseInt(immediate_purchase_price, 10)) {
                                    setErrorPrice(true);
                                  } else {
                                    setErrorPrice(false);
                                  }
                                  if (value && auction_reserve_price && value >= parseInt(auction_reserve_price, 10)) {
                                    setErrorAuctionStartPrice(true);
                                  } else {
                                    setErrorAuctionStartPrice(false);
                                    setErrorAuctionReservePrice(false);
                                  }

                                  if (value <= 0) {
                                    value = 1;
                                  } else if (!value) {
                                    value = null;
                                  }
                                  setBody({
                                    ...body,
                                    auction_start_price: value,
                                  });
                                }}
                              />
                            </td>
                          </tr>

                          <tr>
                            <td>
                              <small className="text-primary">{t('auctionStepPrice')}</small>
                            </td>

                            <td>
                              <input
                                type="number"
                                id="auctionStepPrice"
                                name="auctionStepPrice"
                                maxLength="4"
                                size="4"
                                className={accept_auction === true ? 'rounded' : 'rounded disabled'}
                                disabled={accept_auction !== true}
                                value={accept_auction === true ? auction_step_price : ''}
                                onChange={(e) => {
                                  let value = parseInt(e.target.value, 10);
                                  if (!value) {
                                    value = null;
                                  }
                                  setBody({
                                    ...body,
                                    auction_step_price: value,
                                  });
                                }}
                              />
                            </td>
                          </tr>

                          <tr>
                            <td>
                              <small className="text-primary">{t('auctionReservePrice')}</small>
                              <br />
                              {errorAuctionReservePrice && (
                                <small
                                  className="text-danger d-inline-block w-75 d-sm-inline"
                                  style={{ lineHeight: 1.4 }}
                                >
                                  <Translate code="errorAuctionReservePrice" />
                                </small>
                              )}
                            </td>
                            <td>
                              <input
                                type="number"
                                id="auctionReservePrice"
                                name="auctionReservePrice"
                                maxLength="4"
                                size="4"
                                min="1"
                                className={errorAuctionReservePriceClass || 'rounded disabled'}
                                disabled={accept_auction !== true}
                                value={accept_auction === true ? auction_reserve_price : ''}
                                onChange={(e) => {
                                  let { value } = e.target;
                                  if (value !== '') {
                                    value = parseInt(value, 10);
                                  } else {
                                    value = null;
                                  }
                                  if (value !== null && value < parseInt(auction_start_price, 10)) {
                                    setErrorAuctionReservePrice(true);
                                  } else {
                                    setErrorAuctionReservePrice(false);
                                    setErrorAuctionStartPrice(false);
                                  }

                                  setBody({
                                    ...body,
                                    auction_reserve_price: value,
                                  });
                                }}
                              />
                            </td>
                          </tr>

                          <tr>
                            <td>
                              <small className="text-primary text-bold">{t('acceptImmediatePurchase')}</small>
                            </td>

                            <td>
                              <Switch
                                id="acceptImmediatePurchase"
                                name="acceptImmediatePurchase"
                                isOn={accept_immediate_purchase}
                                onColor="#273C78"
                                handleToggle={(e) => {
                                  setBody({
                                    ...body,
                                    accept_immediate_purchase: e.target.checked,
                                  });
                                }}
                              />
                            </td>
                          </tr>

                          <tr>
                            <td>
                              <small className="text-primary">{t('immediatePurchasePrice')}</small>
                            </td>

                            <td>
                              <input
                                type="number"
                                id="immediatePurchasePrice"
                                name="immediatePurchasePrice"
                                maxLength="4"
                                size="4"
                                min="1"
                                className={purchasePriceClass || 'rounded disabled'}
                                disabled={accept_immediate_purchase !== true}
                                value={
                                  accept_immediate_purchase === true && immediate_purchase_price !== null
                                    ? immediate_purchase_price
                                    : ''
                                }
                                onChange={(e) => {
                                  let value = parseInt(e.target.value, 10);

                                  if (value && value <= parseInt(auction_start_price, 10)) {
                                    setErrorPrice(true);
                                  } else {
                                    setErrorPrice(false);
                                  }

                                  if (value <= 0) {
                                    value = 1;
                                  } else if (!value) {
                                    value = null;
                                  }
                                  setBody({
                                    ...body,
                                    immediate_purchase_price: value,
                                  });
                                }}
                              />
                            </td>
                          </tr>

                          <tr>
                            <td>
                              <small className="text-primary text-bold">{t('acceptSubmission')}</small>
                            </td>

                            <td>
                              <Switch
                                id="acceptSubmission"
                                name="acceptSubmission"
                                isOn={accept_submission}
                                onColor="#273C78"
                                handleToggle={(e) => {
                                  setBody({
                                    ...body,
                                    accept_submission: e.target.checked,
                                  });
                                }}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="d-flex">
                              <div className="w-50">
                                <InfoBullItem
                                  tooltipOpen={tooltipOpen.first}
                                  id="Tooltip-first"
                                  openInfoBull={() => openInfoBull('first')}
                                  message="publicSaleInfoBubble"
                                />
                                <small className="text-primary text-bold ml-2">{t('publicSale')}</small>
                              </div>

                              <input
                                id="publicSale"
                                name="publicSale"
                                checked={_.get(body, 'distribution_lists', null) && btnPublic}
                                onChange={handleChangePublicSale}
                                type="checkbox"
                                className="align-middle ml-2"
                              />
                            </td>
                            <td>
                              <InfoBullItem
                                tooltipOpen={tooltipOpen.third}
                                id="Tooltip-third"
                                openInfoBull={() => openInfoBull('third')}
                                message="nationalPublicSaleInfoBubble"
                              />
                              <small className="text-primary text-bold ml-2">{t('nationalPublicSale')}</small>
                              <input
                                id="nationalPublicSale"
                                name="nationalPublicSale"
                                onChange={handleChangeNationalSale}
                                type="checkbox"
                                className="align-middle ml-2"
                                checked={_.get(body, 'distribution_lists', null) && !btnPrivate && btnNationalSale}
                              />
                            </td>
                          </tr>

                          <tr>
                            <td className="d-flex">
                              <div className="w-50">
                                <InfoBullItem
                                  tooltipOpen={tooltipOpen.second}
                                  id="Tooltip-second"
                                  openInfoBull={() => openInfoBull('second')}
                                  message="privateSaleInfoBubble"
                                />
                                <small className="text-primary text-bold ml-2">{t('privateSale')}</small>
                              </div>
                              <input
                                id="privateSale"
                                name="privateSale"
                                checked={btnPrivate}
                                onChange={handleChangePrivateSale}
                                type="checkbox"
                                className="align-middle ml-2"
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </Col>
                </Row>
                {btnPrivate && groupList.length > 0 && (
                  <Row className="mt-2">
                    <Col xs="12" sm="6" lg="5" xl="4">
                      <Select
                        id="group"
                        className="rounded"
                        isMulti
                        value={groupList.filter((i) => body.distribution_lists?.includes(i.value))}
                        options={groupList}
                        placeholder={t('userGroup')}
                        onChange={(selectedOptions) => {
                          if (!selectedOptions) {
                            setRequiredError(true);
                            setBody({ ...body, distribution_lists: [] });
                          } else {
                            setRequiredError(false);
                            setBody({
                              ...body,
                              distribution_lists: selectedOptions ? selectedOptions.map((opt) => opt.value) : [],
                            });
                          }
                        }}
                        isSearchable={false}
                      />
                      {requiredError && <div className="text-danger mt-1">{t('distributionlistIsRequired')}</div>}
                    </Col>
                  </Row>
                )}
                <Row className="mt-2">
                  <Col xs="12" sm="6" lg="5" xl="4">
                    <Label className="text-primary text-left" for="startDate">
                      <Translate code="startDate" />
                    </Label>
                    <DatePicker
                      className={errorDate === true ? 'form-control rounded error' : 'form-control rounded'}
                      name="startDate"
                      id="startDate"
                      onChange={(e) => {
                        setBody({
                          ...body,
                          startDate: moment(e).format('YYYY-MM-DD'),
                        });
                      }}
                      selected={body.startDate ? moment(body.startDate).toDate() : ''}
                      dateFormat={appLang === 'DE' ? datesFormat[appLang] : datesFormat.default}
                      placeholderText={t('long_date_placeholder')}
                      autoComplete="off"
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xs="12" sm="6" lg="5" xl="4">
                    <Label className="text-primary text-left" for="startTime">
                      <Translate code="startTime" />
                    </Label>
                    <input
                      type="time"
                      id="startTime"
                      name="startTime"
                      className={errorDate === true ? 'form-control rounded error' : 'form-control rounded'}
                      value={body.startTime}
                      onChange={(e) => {
                        let value;
                        if (e.target.value) {
                          value = e.target.value;
                        } else {
                          value = null;
                        }
                        setBody({
                          ...body,
                          startTime: value,
                        });
                      }}
                    />
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col xs="12" sm="6" lg="5" xl="4">
                    <Label className="text-primary text-left" for="endDate">
                      <Translate code="endDate" />
                    </Label>
                    <DatePicker
                      className={errorDate === true ? 'form-control rounded error' : 'form-control rounded'}
                      name="endDate"
                      id="endDate"
                      onChange={(e) => {
                        setBody({
                          ...body,
                          endDate: moment(e).format('YYYY-MM-DD'),
                        });
                      }}
                      selected={body.endDate ? moment(body.endDate).toDate() : ''}
                      dateFormat={appLang === 'DE' ? datesFormat[appLang] : datesFormat.default}
                      placeholderText={t('long_date_placeholder')}
                      autoComplete="off"
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xs="12" sm="6" lg="5" xl="4">
                    <Label className="text-primary text-left" for="endTime">
                      <Translate code="endTime" />
                    </Label>
                    <input
                      type="time"
                      id="endTime"
                      name="endTime"
                      className={errorDate === true ? 'form-control rounded error' : 'form-control rounded'}
                      value={body.endTime}
                      onChange={(e) => {
                        let value;
                        if (e.target.value) {
                          value = e.target.value;
                        } else {
                          value = null;
                        }
                        setBody({
                          ...body,
                          endTime: value,
                        });
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs="12" sm="6" lg="5" xl="4">
                    <Label className="text-primary text-left" for="salesComment">
                      <Translate code="salesComment" />
                    </Label>
                    <Input
                      type="textarea"
                      name="salesComment"
                      id="salesComment"
                      className="rounded"
                      onChange={(e) => setBody({ ...body, comment: e.target.value })}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xs="12" sm="6" lg="5" xl="4">
                    <button
                      className={`btn btn-block text-uppercase
                          ${disabled ? 'btn-4' : 'btn-1'}`}
                      onClick={handleCreate}
                      disabled={disabled}
                      type="button"
                    >
                      {isLoading && <Spinner size="sm" />}
                      {t('send')}
                    </button>
                  </Col>
                </Row>
              </>
            )}
          </>
        )}
      <GroupListModel isOpen={isOpen} toggle={toggle} />
    </>
  );
};

export default ManuelSale;

ManuelSale.propTypes = {
  postOffer: PropTypes.func.isRequired,
  showForm: PropTypes.bool.isRequired,
  offers: PropTypes.oneOfType([PropTypes.array, PropTypes.shape()]).isRequired,
  showManualTitle: PropTypes.bool.isRequired,
  postAnnonceAt: PropTypes.func.isRequired,
  recordTypeId: PropTypes.number.isRequired,
  counterInspection: PropTypes.oneOfType([PropTypes.array, PropTypes.shape()]).isRequired,
  expertiseCosts: PropTypes.string,
};

ManuelSale.defaultProps = {
  expertiseCosts: null,
};

const GroupListModel = ({ isOpen, toggle }) => (
  <Modal isOpen={isOpen} toggle={toggle} centered>
    <ModalBody className="pb-0">
      <div className="form-group text-Alert" data-cy="textAlertLogout">
        <span>{t('popUpPrivateSale1')}</span>
      </div>
      <span>{t('popUpPrivateSale12')}</span>
    </ModalBody>
    <ModalFooter>
      <button type="button" className="btn btn-1" onClick={toggle}>
        <Translate code="close" />
      </button>
    </ModalFooter>
  </Modal>
);

GroupListModel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};
